<template>
  <div>
    <div>
      <div
        class="line-content"
        v-for="(item, index) in parentData"
        :key="index"
      >
        <div class="line-content--item" flex>
          <div
            flex
            v-for="(options, optionsIndex) in item"
            :key="optionsIndex"
            class="option-item"
            @click="openDialog(index)"
          >
            <div style="margin-right: 10px" class="questionSeq">
              {{
                optionsIndex === 0 ? uppercaseStr[index] : lowercaseStr[index]
              }}
            </div>
            <bc-view-common
              placeholder="点击编辑选项"
              style="flex: 1; min-width: 0"
              :content="options.content"
              :fileInfo="options.fileInfo"
            ></bc-view-common>
          </div>
        </div>
      </div>

      <el-button
        @click="createOption"
        class="create-option"
        icon="el-icon-circle-plus"
      >
        添加选项
      </el-button>
    </div>

    <el-dialog
      top="60px"
      width="640px"
      destroy-on-close
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
      append-to-body
      :visible.sync="isShowDialog"
    >
      <div>
        <div
          v-for="(item, position) in optionsList[openPosition]"
          :key="position"
          flex="cross:center"
          class="edit-item"
        >
          <div
            style="
              width: 602px;
              padding-bottom: 16px;
              border-bottom: 2px solid #f2f2f2;
            "
          >
            <div class="dot-title--dialog" flex="main:justify">
              <div>
                选项{{
                  position === 0
                    ? uppercaseStr[openPosition]
                    : lowercaseStr[openPosition]
                }}
              </div>

              <div flex>
                <bc-upload
                  relationType="stem-files"
                  @startUpload="startUpload"
                  @finishUpload="finishUpload($event, position)"
                  @uploadErr="loading && loading.close()"
                >
                  <el-button
                    class="dialog-title--upload"
                    type="primary"
                    size="medium"
                    ref="uploadBtn"
                    >上传文件</el-button
                  >
                </bc-upload>
              </div>
            </div>
  
            <template
              v-if="
                optionsList[openPosition][position].fileInfo.fileSuffix &&
                optionsList[openPosition][position].fileInfo.fileSuffix &&
                optionsList[openPosition][position].fileInfo.fileSuffix
              "
            >
              <bc-file-render
                style="margin-top: 16px"
                @remove="removeFile(position)"
                @againUpload="againUpload(position)"
                :fileInfo="optionsList[openPosition][position].fileInfo"
              ></bc-file-render>
            </template>
          </div>
        </div>

        <div style="width: 602px">
          <el-button
            @click="removeOptions"
            class="create-option"
            icon="el-icon-remove"
            v-if="optionsList.length > minLength"
          >
            删除此选项
          </el-button>

          <div style="text-align: center" class="mt-3">
            <el-button class="dialog-close" @click="close">关闭</el-button>
            <el-button class="dialog-submit" type="primary" @click="submit"
              >完成</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import XEUtils from "xe-utils";

const lowercaseStr = "abcdefghijklmnopqrstuvwxyz".split("");
const uppercaseStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
import upIcon from "@/assets/images/up.png";
import downIcon from "@/assets/images/down.png";

import { getPlainText } from "@/utils";
export default {
  name: "bc-line-question",
  props: {
    value: {
      type: String,
      default: "",
    },
    limit: {
      type: Number,
      default: 2,
    },
    maxLength: {
      type: Number,
      default: 15,
    },
    minLength: {
      type: Number,
      default: 2,
    },
  },
  watch: {
    valueAndLimit: {
      handler(val) {
        try {
          this.optionsList = JSON.parse(val.value);
        } catch (err) {
          // this.optionsList = { left: this.createDefaultData(val.minLength, 'upper'), right: this.createDefaultData(val.minLength, 'lower') }

          for (let i = 0; i < val.minLength; i++) {
            this.optionsList.push([
              this.createDefaultData(i, "upper"),
              this.createDefaultData(i, "lower"),
            ]);
          }
        }
        this.parentData = XEUtils.clone(this.optionsList, true);
      },
      immediate: true,
    },
    haveMedia: {
      handler(val) {
        this.$emit("changeHaveMedia", val);
      },
      immediate: true,
    },
  },
  data() {
    return {
      optionsList: [],
      parentData: [],
      lowercaseStr,
      uppercaseStr,
      isShowDialog: false,
      openPosition: 0,
      loading: null,
      upIcon,
      downIcon,
      contentMaxLength: 10000,
    };
  },
  computed: {
    valueAndLimit() {
      return {
        value: this.value,
        minLength: this.minLength,
      };
    },
    haveMedia() {
      let isHave = false;
      isHave = this.optionsList.some((i) =>
        i.some(
          (x) =>
            !!(
              x.fileInfo.fileUrl &&
              x.fileInfo.fileType &&
              x.fileInfo.fileSuffix
            )
        )
      );
      return isHave;
    },
  },
  mounted() {
    this.getConfigKey("rich-text-maxlength").then((response) => {
      // console.log(response)
      this.contentMaxLength = Number(response.msg);
    });
  },
  methods: {
    createDefaultData(index, type) {
      return {
        title: type === "upper" ? uppercaseStr[index] : lowercaseStr[index],
        content: "",
        fileInfo: {},
      };
    },
    submit() {
      let l = this.optionsList[this.openPosition][0],
        r = this.optionsList[this.openPosition][1];

      let objReg = /<img [^>]*src=['"]([^'"]+)[^>]*>/g;

      let leftImage = l.content.match(objReg);
      let rightImage = r.content.match(objReg);

      let left = !getPlainText(l.content) && !leftImage && !l.fileInfo.fileUrl;
      let right =
        !getPlainText(r.content) && !rightImage && !r.fileInfo.fileUrl;
      if (left || right) {
        this.$message.error("请填写完整选项信息, 内容和文件必须存在一个");
        return;
      }
      if (
        l.content &&
        getPlainText(l.content) &&
        getPlainText(l.content).length > this.contentMaxLength
      ) {
        this.$message.error("内容最多输入" + this.contentMaxLength + "个字符");

        return;
      }
      if (
        r.content &&
        getPlainText(r.content) &&
        getPlainText(r.content).length > this.contentMaxLength
      ) {
        this.$message.error("内容最多输入" + this.contentMaxLength + "个字符");

        return;
      }
      this.isShowDialog = false;
      this.$nextTick(() => {
        // let data = {
        //   left: this.optionsList.left.map((i, idx) => ({...i, title: this.uppercaseStr[idx]})),
        //   right: this.optionsList.right.map((i, idx) => ({...i, title: this.lowercaseStr[idx]}))
        // }
        //
        // console.log(data)
        //
        // this.$emit('input', JSON.stringify(data))

        let data = this.optionsList.map((i, idx) => {
          return i.map((x, index) => {
            let obj = {
              ...x,
              title:
                index === 0 ? this.uppercaseStr[idx] : this.lowercaseStr[idx],
            };

            let objText = getPlainText(x.content);

            let objImage = x.content.match(objReg);

            obj.content = objText || objImage ? x.content : "";

            return obj;
          });
        });

        this.parentData = XEUtils.clone(data, true);

        this.$emit("input", JSON.stringify(data));
      });
    },
    close() {
      this.isShowDialog = false;
      // this.optionsList = XEUtils.clone(this.parentData, true)
    },
    openDialog(position) {
      this.openPosition = position;
      this.isShowDialog = true;
    },
    startUpload() {
      this.loading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    finishUpload(val, position) {
      let data = Object.assign(this.optionsList[this.openPosition][position], {
        fileInfo: val,
      });
      this.$set(this.optionsList[this.openPosition], position, data);
      this.loading && this.loading.close();
    },
    createOption() {
      // this.dialogTitle = '新增选项'
      // this.editModel = 'create'
      // this.$refs.editCommon.open()
      // this.optionsList['left'].push({title: this.uppercaseStr[this.optionsList['left'].length], content: '', fileInfo: {}})
      // this.optionsList['right'].push({title: this.lowercaseStr[this.optionsList['right'].length], content: '', fileInfo: {}})

      if (this.optionsList.length < this.maxLength) {
        this.optionsList.push([
          this.createDefaultData(this.optionsList.length, "upper"),
          this.createDefaultData(this.optionsList.length, "lower"),
        ]);

        this.parentData = XEUtils.clone(this.optionsList, true);
        this.$emit("input", JSON.stringify(this.parentData));
      } else {
        this.$message.error(`最多添加${this.maxLength}个选项`);
      }
    },

    removeFile(position) {
      let data = Object.assign(this.optionsList[this.openPosition][position], {
        fileInfo: { fileUrl: "", fileType: "", fileSuffix: "" },
      });
      this.$set(this.optionsList[this.openPosition], position, data);
    },
    againUpload(index) {
      this.$refs.uploadBtn[index].$el.click();
    },
    removeOptions() {
      this.$confirm(`删除此选项？`, "提示")
        .then((res) => {
          if (res === "confirm") {
            this.isShowDialog = false;
            // this.openPosition = 0
            this.$nextTick(() => {
              this.optionsList.splice(this.openPosition, 1);

              let data = this.optionsList.map((i, idx) => {
                return i.map((x, index) => ({
                  ...x,
                  title:
                    index === 0
                      ? this.uppercaseStr[idx]
                      : this.lowercaseStr[idx],
                }));
              });

              this.parentData = XEUtils.clone(data, true);

              this.$emit("input", JSON.stringify(data));
            });
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.line-content {
  width: 100%;
  .line-content--item {
    flex: 1;
    ::v-deep .stem-content {
      height: 100%;
    }
  }

  & + .line-content {
    margin-top: 10px;
  }
  //.line-content--item + .line-content--item {
  //  margin-left: 100px;
  //}
}
//.line-content--item + .line-content--item {
//}
.option-item + .option-item {
  //margin-top: 10px;
}
.create-option {
  width: 100%;
  margin-top: 10px;
  border-style: dashed !important;
}

.option-item {
  flex: 1;
  min-width: 0;
}

.option-item + .option-item {
  margin-left: 100px;
}
.edit-item {
  margin-bottom: 10px;
}
</style>
